import { Box, Flex, Text } from '@chakra-ui/react';

import { useScrollOnClick } from '@/hooks';
import { Alphabet } from '@/utils/models/inventory-items';

interface LettersListProps {
  letters: Alphabet[];
}

export const LettersList = ({ letters }: LettersListProps) => {
  const handleScrollToElement = useScrollOnClick();

  return (
    <Flex as="ul" mt={{ base: 8, md: 0 }} flexWrap="wrap" justifyContent="center" listStyleType="none">
      {letters.map(({ letter }) => {
        const isLinkDisabled = false;

        return (
          <Box
            as="li"
            bg="bg-secondary"
            w="40px"
            h="40px"
            key={`letters-list-letter-${letter}`}
            pointerEvents={isLinkDisabled ? 'none' : 'auto'}
            cursor={isLinkDisabled ? 'initial' : 'pointer'}
            data-element={letter}
            onClick={handleScrollToElement}
            display="flex"
            alignItems="center"
            justifyContent="center"
            _hover={!isLinkDisabled ? { bg: 'black' } : {}}
            transition="background-color 0.2s ease-in-out"
            sx={{
              '&:hover span': !isLinkDisabled ? { color: 'white' } : {},
            }}
          >
            <Text
              as="span"
              variant={{ base: 'text-xl/lineHeight-7/font-medium' }}
              transition="color 0.2s ease-in-out"
              pointerEvents="none"
            >
              {letter}
            </Text>
          </Box>
        );
      })}
    </Flex>
  );
};
